import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Counter {
  counterPDFs: number;
  counterJogadores: number;
  counterTorneios: number;
  counterClubes: number;
  counterJogos: number;
  counterReservas: number;
  status: 'loading' | 'success' | 'error';
}

export interface CounterResponse {
  counterPDFs: number;
  counterJogadores: number;
  counterTorneios: number;
  counterClubes: number;
  counterJogos: number;
  counterReservas: number;
}

const initialState: Counter = {
  counterPDFs: 0,
  counterJogadores: 0,
  counterTorneios: 0,
  counterClubes: 0,
  counterJogos: 0,
  counterReservas: 0,
  status: 'loading',
};

const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setCounter: (state, action: PayloadAction<CounterResponse>) => {
      return {
        ...state,
        ...action.payload,
        status: 'success',
      };
    },
  },
});

export const { setCounter } = counterSlice.actions;

export default counterSlice.reducer;
